import { type ReactNode } from 'react';
import { useLingui } from '@lingui/react';
import { NumberFormat } from '@startuptools/ui/NumberFormat';

export const ShareCapitalRow = ({
  capital,
  header,
  shares,
  currency,
}: {
  header: ReactNode;
  shares: string;
  capital: string;
  currency: string;
}) => {
  const { i18n } = useLingui();
  return (
    <tr>
      <th>{header}</th>
      <td align="right">
        <NumberFormat locale={i18n.locale} maximumFractionDigits={0}>
          {shares}
        </NumberFormat>
      </td>
      <td align="right">
        <NumberFormat locale={i18n.locale} variant="currency" currency={currency}>
          {capital}
        </NumberFormat>
      </td>
    </tr>
  );
};
